import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { Button } from "antd";
import { getSummary, getAggHeartRate, getAggMetrics } from "../../utils/api";
import ProgressRing from "./ProgressRing";
import PhoneHeartRate from "./PhoneHeartRate";
import PhoneHRV from "./PhoneHRV";
import { CalendarOutlined } from "@ant-design/icons";

import "./Phone.css";

function Phone({ dashboardStore, authStore, orgDashboardStore }) {
  const userCode = "clean-hrv";
  const [summary, setSummary] = useState([]);
  const [day, setDay] = useState("2023-06-04");
  const [metrics, setMetrics] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      let summary_ = await getSummary(userCode);
      summary_ = summary_
        .sort((a, b) => a.day.localeCompare(b.day))
        .filter((x) => x.day <= "2023-06-17");
      setSummary(summary_);
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const metrics = await getAggMetrics(userCode, day+"T00:00:00Z", day+"T23:00:00Z", 10);
      setMetrics(metrics);
    };

    fetchData();
  }, [day]);

  const dayChanged = (day) => {
    setDay(day);
  };

  return (
    <>
      <div className="Phone">
        <div>
          <div style={{ float: "right" }}>
            <Button className="Phone__calendar" type="text" size="large">
              <CalendarOutlined />
            </Button>
            <div></div>
          </div>
          <div className="Phone__day">Today</div>
        </div>
        <div style={{ marginLeft: "7px", paddingTop: "10px", clear: "both" }}>
          {summary.map((x) => (
            <ProgressRing key={x.day} day={x.day} setDay={dayChanged} />
          ))}
        </div>
        <div className="DateFilter">
          <Button type="text">1H</Button>
          <Button type="text">6H</Button>
          <Button type="primary">1D</Button>
        </div>

        <div className="Phone__day" style={{ clear: "both" }}>
          <div style={{ color: "#dadada" }}>Heart Rate</div>
          <div style={{ fontSize: "20px" }}>
            102 <span style={{ fontSize: "12px" }}>bpm</span>
          </div>
        </div>

        {metrics && metrics.length > 0 && (
          <PhoneHeartRate
            data={metrics}
            day={day}
            style={{ width: "100%", height: "130px" }}
          ></PhoneHeartRate>
        )}

        <div className="Phone__day" style={{ clear: "both" }}>
          <div style={{ color: "#dadada" }}>HRV</div>
        </div>
        {metrics && metrics.length > 0 && (
          <PhoneHRV
            data={metrics}
            day={day}
            style={{ width: "100%", height: "150px" }}
          ></PhoneHRV>
        )}
      </div>
    </>
  );
}

export default observer(Phone);
